import { useEffect, Component } from "react";
import { MotionConfig } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import About from "@/components/About";
import Team from "@/components/Team";
import WhyUs from "@/components/WhyUs";
import Projects from "@/components/Projects";
import Process from "@/components/Process";
import CtaBanner from "@/components/CtaBanner";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import LeadPopup from "@/components/LeadPopup";
import AdminLeads from "@/pages/AdminLeads";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(err) {
        console.error(err);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-cream text-burgundy font-serif text-2xl">
                    Something went wrong. Please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function Site() {
    useEffect(() => {
        // smooth momentum scrolling
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        // smooth anchor navigation (header offset)
        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const hash = a.getAttribute("href");
            if (!hash || hash.length < 2) return;
            const el = document.querySelector(hash);
            if (!el) return;
            e.preventDefault();
            lenis.scrollTo(el, { offset: -80 });
            window.dispatchEvent(new Event("lenis:navigate"));
        };
        document.addEventListener("click", onClick);

        return () => {
            document.removeEventListener("click", onClick);
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="min-h-screen bg-cream text-charcoal font-sans overflow-x-clip">
            <div className="grain" aria-hidden="true" />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <About />
                <Team />
                <WhyUs />
                <Projects />
                <Process />
                <CtaBanner />
                <Testimonials />
                <Contact />
                <Booking />
            </main>
            <Footer />
            <Chatbot />
            <LeadPopup />
        </div>
    );
}

function App() {
    return (
        <MotionConfig reducedMotion="user">
            <BrowserRouter>
                <ErrorBoundary>
                    <Toaster position="bottom-center" richColors closeButton />
                    <Routes>
                        <Route path="/admin/leads" element={<AdminLeads />} />
                        <Route path="*" element={<Site />} />
                    </Routes>
                </ErrorBoundary>
            </BrowserRouter>
        </MotionConfig>
    );
}

export default App;
